import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getAllCategories } from "../../redux/actions/InventoryAction";
import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";
import { Link } from "react-router-dom";
import CategoryManager from "../../components/inventoryManagement/Category/CategoryList";

const InventoryCategory = ({ nav }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userSignIn);

  useEffect(() => {
    if (!userInfo) {
      navigate("/sign-in");
    } else {
      dispatch(getAllCategories());
    }
    window.scrollTo(0, 0);
  }, [userInfo, navigate, dispatch]);

  return (
    <>
      {userInfo && (
        <div className={nav.isSidebar}>
          <Header nav={nav} />
          <Sidebar nav={nav} />
          {/* Start content */}
          <main className="page-content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  Inventory Management
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="bx bx-home-alt" />
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Manage Categories
                </li>
              </ol>
            </nav>
            <h5 className="pt-3 text-white">
              <i className="fadeIn animated bx bx-file" />
               Category Management
            </h5>
            <br />

            {/* Dynamic content */}
            <CategoryManager />
          </main>
        </div>
      )}
    </>
  );
};

export default InventoryCategory;